
import { Component, Mixins } from "vue-property-decorator";
import EventLinksMixin from "@/mixins/EventLinksMixin";

@Component({
	components: {}
})
export default class EventLinksList extends Mixins(EventLinksMixin) {

	async created(): Promise<void> {
		await this.retrieveFirstPage();
	}
}
